
export const ApiKey = {

  apiKey: "AIzaSyB-rcJZu2OBGc1bi9Fq4Hy7tQi-Pxyl_jI",

  authDomain: "blog-system-f0779.firebaseapp.com",

  projectId: "blog-system-f0779",

  storageBucket: "blog-system-f0779.appspot.com",

  messagingSenderId: "470608764369",

  appId: "1:470608764369:web:a319ad496fb355211714f0",

  measurementId: "G-C43GZZEMM3"

};
